@let sidebarConfig = $sidebarConfig();
<!-- usage: wrap your content in the sidebar layout
  one inner item should have directive attribute unityMainTile
  the other should have directive attribute unitySidebarTile -->
<kendo-gridlayout class="layout" [gap]="$sidebarLayoutGap()" [cols]="$colWidths()">
  <kendo-gridlayout-item class="layout-item" [row]="sidebarConfig.mainRow" [col]="sidebarConfig.mainCol">
    <kendo-stacklayout class="layout-stack" orientation="vertical" [gap]="5">
      <ng-content select="[unityMainTile]" />
    </kendo-stacklayout>
    <!--
    <el unityMainTile>
      <main content...>
      </el>
    -->
  </kendo-gridlayout-item>
  <kendo-gridlayout-item class="layout-item" [row]="sidebarConfig.sideRow" [col]="sidebarConfig.sideCol">
    <kendo-stacklayout class="layout-stack" orientation="vertical" [gap]="5">
      <ng-content select="[unitySidebarTile]" />
    </kendo-stacklayout>
    <!--
    <el unitySidebarTile>
      <sidebar content...>
      </el>
    -->
  </kendo-gridlayout-item>
</kendo-gridlayout>
